import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export default function BrandCcl() {
  return (
    <div className="navbar-brand NavBar__brandContainer NavBar__brandContainer--ccl">
      <Link to="/" className="NavBar__brandLogo">
        <img src="https://cdn.fanatical.com/production/brand/fanatical-logo-white.svg" alt="Fanatical" />
      </Link>
      <div className="NavBar__brandAssociation">
        <FormattedMessage id="brand-ccl.curated-for" defaultMessage="Curated for" />
        <Link to="/">
          <img src="https://cdn.fanatical.com/production/brand/co-brands/ccl-logo-light.svg" alt="CCL" className="NavBar__brandAssociation__image" />
        </Link>
      </div>
    </div>
  );
}
